module.exports = __webpack_public_path__ + "img/pp-profile.3baf044e.webp";